export const ROLES = {
  //appointment
  APPOINTMENT_VIEW_ROLE: "appointment-page.view",
  ADD_PATIENT_VIEW_ROLE: "patient-add-page.view",
  //patient
  PATIENT_SEARCH: "patient-search.view",

  // patient medical
  PATIENT_MEDICAL_VIEW: "patient-medical.view",
  DOCTOR_APPOINTMENT_VIEW_ROLE: "doctor-appointment.view",
  // prescription
  PRESCRIPTION_TABLE_VIEW_ROLE: "prescription-table.view",
  PRESCRIPTION_ADD_ROLE: "prescription.add",

  // admin
  ADMIN_EDIT_ROLE: "admin.edit",
};
